import React from 'react';

export default function TopLeftCorner() {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 0H0V1V23H1V1H23V0H1Z" fill="white" />
    </svg>
  );
}
